// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2xDRS{width:600px;margin:0 auto}", ""]);
// Exports
exports.locals = {
	"root": "_2xDRS"
};
module.exports = exports;
